/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "paymentactivator": {
        "nested": {
          "DeactivationType": {
            "values": {
              "LEGACY": 0,
              "TEST_DO_NOT_USE": 1,
              "COMPLIANCE": 2,
              "COMPLIANCE_AUTOMATED_HARDBLOCK": 3,
              "COMPLIANCE_NON_HARDBLOCKING": 4,
              "NO_SIRET": 5,
              "FRAUD_RISK": 6,
              "COMPLIANCE_STALE_IDENTITY": 7,
              "TAX_IRS_B_NOTICE": 8,
              "BANK_GRACE_PERIOD_EXPIRED": 9,
              "COMPLIANCE_DO_NOT_REACTIVATE": 10,
              "COMPLIANCE_FAILED_INDIVIDUAL_NAME_CHANGE": 11,
              "COMPLIANCE_ONGOING_MONITORING_FAILURE": 12
            }
          },
          "DeactivationState": {
            "values": {
              "BLOCKING": 0,
              "CLEARED": 1
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.paymentactivator?.nested?.DeactivationType && !$root.nested?.squareup?.nested?.paymentactivator?.nested?.DeactivationState) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DeactivationType @ squareup/paymentactivator/deactivations.proto at 12:1
 */
export const DeactivationType = $root.lookupEnum('squareup.paymentactivator.DeactivationType').values;
/**
 * SOURCE DeactivationState @ squareup/paymentactivator/deactivations.proto at 58:1
 */
export const DeactivationState = $root.lookupEnum('squareup.paymentactivator.DeactivationState').values;